import styled from "styled-components";

// 모달의 내용을 감싸는 wrapper
const ModalContentContainer = styled.div`
    
`

export default ModalContentContainer